import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { getErrorMessage } from '../../../utils/helpers/form';
import {
  getMails,
  addMail,
  updateMail,
  deleteMail,
} from '../../../redux/thunks/mails';
import ErrorMessage from '../../../components/error-message/error-message.component';
import MailCard from '../../../components/mail-card/mail-card.component';

const Mails = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError,
    clearErrors,
  } = useForm();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { mails, isFetching, isAdding, isUpdating } = useSelector(
    (state) => state.entities.mails
  );

  useEffect(() => {
    dispatch(getMails({}));
  }, []);

  useEffect(() => {
    watch(() => clearErrors('invalid'));
  }, [watch, clearErrors]);

  const handleAddMail = (formData) => {
    const { email } = formData;
    if (!email || !email.trim().length) {
      return setError('email', {
        type: 'invalid',
        message: 'יש להזין מייל',
      });
    }

    const onSuccess = (message) => {
      enqueueSnackbar(message, { variant: 'success' });
      setValue('email', '');
    };

    const onError = (error) => enqueueSnackbar(error, { variant: 'error' });

    dispatch(
      addMail({
        email: email.trim(),
        onSuccess,
        onError,
      })
    );
  };

  const handleUpdateMail = (id, value) => {
    const onSuccess = (message) => enqueueSnackbar(message, { variant: 'success' });

    const onError = (error) => enqueueSnackbar(error, { variant: 'error' });

    dispatch(
      updateMail({
        id,
        email: value,
        onSuccess,
        onError,
      })
    );
  };

  const handleDeleteMail = (id) => {
    const onSuccess = (message) =>
      enqueueSnackbar(message, { variant: 'success' });

    const onError = (error) => enqueueSnackbar(error, { variant: 'error' });

    dispatch(
      deleteMail({
        id,
        onSuccess,
        onError,
      })
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Card>
        <Card.Body>
          <Card.Text
            style={{
              display: 'flex',
              gap: '1rem',
            }}
          >
            <Form.Control
              disabled={isAdding}
              placeholder="מייל"
              type="text"
              {...register('email', { required: true })}
            />
            <Button variant="primary" onClick={handleSubmit(handleAddMail)}>
              הוסף
            </Button>
            {isAdding && <span>טוען...</span>}
          </Card.Text>
          {errors?.email && (
            <ErrorMessage error={getErrorMessage(errors?.email?.type)} />
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <Card.Text>
            {isFetching ? (
              <div>טוען...</div>
            ) : (
              <ListGroup variant="flush">
                {mails.length === 0 && 'אין מיילים'}
                {mails.map(({ _id, email }) => (
                  <ListGroup.Item key={_id}>
                    <MailCard
                      id={_id}
                      value={email}
                      handleSave={handleUpdateMail}
                      handleDelete={() => handleDeleteMail(_id)}
                      isUpdating={isUpdating[_id]}
                    />
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Mails;
